export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  READINESS_ASSESSMENT: {
    ROOT: '/readiness/assessment',
    WIZARD: '/readiness/assessment/wizard',
    DASHBOARD: '/readiness/assessment/dashboard'
  },
  OPPORTUNITY_ASSESSMENT: {
    ROOT: '/assessment',
    WIZARD: '/assessment/wizard'
  },
  PERMIT_BENCHMARKING: {
    ROOT: '/benchmarking',
    WIZARD: '/benchmarking/wizard',
    NEW: '/benchmarking/new',
    LEGACY: '/benchmarking/legacy'
  },
  SHARED: {
    OPPORTUNITY: '/shared/opportunity/:id',
    READINESS: '/shared/readiness/:id',
    PROCESS: '/shared/process/:id'
  }
} as const